import {CompetitorTransfersPageRouteMetaDataModel} from "./competitor.transfers-page.route.meta-data.model";
import {PAGES} from "../../../../../core/consts";
import {CompetitorPageRouteConfig} from "../../../models/competitor.page-route.config";

export class CompetitorTransfersPageRouteConfig extends CompetitorPageRouteConfig {
  static injectables = [];

  constructor() {
    super({
      name: PAGES.COMPETITOR.transfers,
      path: 'transfers',
      componentImport: () => import("../components/competitor.transfers-page" /* webpackChunkName: "competitor.transfers-page" */),
      metadataType: CompetitorTransfersPageRouteMetaDataModel
    });
  }
}